import {CMSConditions, FlowMetaData, Route, StageRequest} from '../../shared/models';
import {AfterViewChecked, Component, DoCheck, OnDestroy, OnInit, Pipe, PipeTransform, ViewChild, } from '@angular/core';
import {EMPTY, Observable, Subscription} from 'rxjs';
import {FlowManagerService} from '../flow/services/flow-manager.service';
import {Environment, SharedService} from '../../core/services/store/shared-store/shared-storage.service';
import {MatTabChangeEvent, MatTabGroup} from '@angular/material/tabs';
import {AbstractControl, FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {flatMap, map, mergeMap, shareReplay, take, tap} from 'rxjs/operators';
import {swalMini} from '../../shared/utils/utils';
import {RolesService} from '../../core/services/roles/roles.service';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import {CMSService} from '../../shared/components/cms/service/cms.service';
import {FlowBuilderService} from '../flow/services/flowBuilder/flow-builder.service';
import {
  DISPLAY_TYPE_CHANNELS_KEYS
} from '../flow/components/node-delegator/nodes/templates/display-type-dialog/displayTypeUtils';
import {RouteApiTokenService} from './services/route-api-token.service';
import {Clipboard} from '@angular/cdk/clipboard';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {StateService} from '../../core/services/store/state/state.service';
import {FlowModeState} from '../../shared/models/state/Flow';
import {spaceOnName} from '../../shared/utils';
import {CHANNELS} from './routing.pipe';

interface Service {
  id: string;
  name: string;
  serviceType: string;
  providerType: string;
}

enum FlowPathRequest {
  flowRootFolder = 'rootFolder',
  flowName = 'flowName',
  flowStep = 'step',
  flowFullPath = 'flowPath',
  flowPathContainerWidth = 'width',
  multipleFoldersList = 'multipleFolders',
  isEllipsesPresent = 'isEllipsesPresent',
  isRootFolderPresent = 'isRootFolderPresent',
  isMultipleFoldersPresent = 'isMultipleFoldersPresent'
}

const copyTrigger = (animationName: string, bottomValue: string) => {
  return trigger(animationName, [
    state('true', style({
      bottom: bottomValue,
      visibility: 'visible'
    })),
    state('false', style({
      bottom: '*',
      visibility: 'hidden'
    })),
    transition(':enter, false => true', animate('200ms ease-in')),
    transition(':leave', [
      animate('200ms', style({ visibility: 'hidden' }))
    ])
  ]);
};



@Component({
  selector: 'app-routing',
  templateUrl: './routing.component.html',
  styleUrls: ['./routing.component.scss'],
  animations: [
      copyTrigger('copyApiTokenAnimation', '5px'),
      copyTrigger('copyUrlAnimation', '45px'),
      trigger('rotateApiRegeneration', [
        transition('true <=> false', [
          style({ transform: 'rotate(0deg)' }),
          animate('500ms', style({ transform: 'rotate(-360deg)' })),
        ]),
      ])
  ]
})
export class RoutingComponent implements OnInit, DoCheck, AfterViewChecked, OnDestroy {
  availableChannels: any[] = [];
  routes: FormGroup = null;
  globalEnvironment: Environment;
  selectedChannelIndex = 0;
  selectedChannel = 0;
  flowMetaData$: Observable<FlowMetaData[]>;
  flows$: Observable<Map<string, string>>;
  flows: any;
  flowStepsMap = new Map();
  routesToDelete: string[] = [];
  resetOnDelete = true;
  originalRouteIdMap: any = {};
  newItemsRouteIdMap: string[] = [];
  routeSavedOrDeleted: Boolean = false;
  canSaveRoute: Boolean = false;
  routeId: Boolean = true;
  flowName: Boolean = true;
  step: Boolean = true;
  savingInProgress: Boolean = false;
  currentChannelId = '0';
  initialChannelSet = false;

  showNextSelector: Boolean;
  flowSubscription: Subscription;

  flowPathRequest = FlowPathRequest;

  showFlowStepSelectionModal: Boolean = false;
  flowStepSelectionFormField: any = null;
  editFlowInformation: any = null;
  isApiTokenCopied = false;
  isUrlCopied = false;
  readonly CHANNELS = CHANNELS;

  public services: Service[] = [
    { id: 'chatFlow', name: 'Chat Flow', serviceType: 'ENGINE', providerType: 'FLOW' },
    { id: 'chatDesk', name: 'Chat Desk (Legacy)', serviceType: 'ENGINE', providerType: 'TOUCH' },
    { id: 'agentDesk', name: 'Chat Desk', serviceType: 'AGENT_DESK', providerType: 'TOUCH' },
  ];
  currentService: Service = {
    id: 'chatFlow',
    name: 'Chat Flow',
    serviceType: 'ENGINE',
    providerType: 'FLOW',
  };

  bannerCmsData;
  @ViewChild(MatTabGroup, { static: true }) tabGroup: MatTabGroup;
  integrationListData$: any;
  departmentListData$: any;
  public canEditState: boolean;

  constructor(
    private flowManagerService: FlowManagerService,
    public flowBuilderService: FlowBuilderService,
    private sharedService: SharedService,
    private stateService: StateService,
    private rolesService: RolesService,
    private routeApiTokenService: RouteApiTokenService,
    private clipboard: Clipboard,
    public cmsService: CMSService
  ) {}

  ngOnDestroy(): void {
  }

  serviceAvailable(event: Event, i) {
    this.services.forEach(
      (itm) =>
        itm.name === (<HTMLInputElement>event.target).innerText && (this.currentService = itm)
    );
    const flowNameControl = this.routes.get(
      this.availableChannels[this.selectedChannelIndex]['channel-id'] + '.' + i + '.' + 'flowName'
    );
    const startControl = this.routes.get(
      this.availableChannels[this.selectedChannelIndex]['channel-id'] + '.' + i + '.' + 'start'
    );
    const integrationControl = this.routes.get(
      this.availableChannels[this.selectedChannelIndex]['channel-id'] +
        '.' +
        i +
        '.' +
        'properties' +
        '.' +
        'integration'
    );
    const updateControlsValidator = (flowNameValidator, startValidator, integrationValidator) => {
      flowNameControl.setValidators(flowNameValidator);
      flowNameControl.updateValueAndValidity();
      startControl.setValidators(startValidator);
      startControl.updateValueAndValidity();
      integrationControl.setValidators(integrationValidator);
      integrationControl.updateValueAndValidity();
    };

    switch (this.currentService.name) {
      case 'Chat Flow': {
        updateControlsValidator([Validators.required], [Validators.required], []);
        break;
      }
      case 'Chat Desk (Legacy)': {
        updateControlsValidator([], [], []);
        break;
      }
      case 'Chat Desk': {
        updateControlsValidator([], [], [Validators.required]);
        break;
      }
    }
  }

  ngDoCheck(): void {
    if (
      JSON.stringify(this.globalEnvironment) !==
      JSON.stringify(this.sharedService.getGlobalEnvironment())
    ) {
      this.canEditState = this.canEdit();
      this.getFlowMetaData();
      this.fetchDropdownList(true, 'integrations');
      this.fetchDropdownList(true, 'departments');

      if (this.flows$) {
        this.flows$ = null;
      }

      this.routes = new FormGroup({});
      this.getFlows()
        .pipe(
          tap((x) => {
            this.flows = x;
          }),
          flatMap(() => {
            return this.loadRouteData(this.selectedChannelIndex);
          }),
          tap((x) => {
            this.addChannelRouteFormArray(this.selectedChannelIndex, x);
          })
        )
        .subscribe();

      this.globalEnvironment = Object.assign({}, this.sharedService.getGlobalEnvironment());
    }
  }

  ngOnInit() {
    this.canEditState = this.canEdit();
    this.flowSubscription = this.flowManagerService.getFlows_with_ids(true).pipe(shareReplay(1)).subscribe(flows => {
      this.showNextSelector = true;
      this.flows = flows;
    });

    this.initialChannelSet = true;
    this.bannerCmsData = this.cmsService.cmsCall('3rOeVlDTXePPUDgFsDYPUg', 'entry');
    if (!this.globalEnvironment) {
      this.globalEnvironment = Object.assign({}, this.sharedService.getGlobalEnvironment());
    }
    this.getFlowMetaData();
    this.routes = new FormGroup({});
    this.flowManagerService
      .getAllChannelConfig()
      .pipe(
        tap((config) => {
          this.availableChannels = config;
        }),
        tap(() => {
          this.checkFlowIssue();
          this.getFlows().pipe(
            tap((x) => {
              this.flows = x;
            }),
            mergeMap(() => {
              return this.loadRouteData(0);
            }),
            tap((x) => {
              const channelId =
                this.availableChannels[this.selectedChannelIndex]['channel-id'].toString();
              this.addChannelRouteFormArray(channelId, x);
            })
          );
        })
      )
      .subscribe();
    this.fetchDropdownList(true, 'integrations');
    this.fetchDropdownList(true, 'departments');
  }

  fetchDropdownList(reload: boolean, endpoint: string) {
    this.flowManagerService.getIntDepDropdownList(reload, endpoint).pipe(
        tap((resp: any) => {
              if (resp.status === 200) {
                const currentList = [];
                const prodList = [];
                const sandboxList = [];
                const holderValues = resp.body;
                let currentHolderObject = null;
                for (const holderItem in holderValues) {
                  if ( endpoint === 'integrations' ) {
                    if (holderValues[holderItem].production === true) {
                    currentHolderObject = {
                      channelTypeId: holderValues[holderItem].channelTypeId,
                      apiToken: holderValues[holderItem].apiToken,
                      production: holderValues[holderItem].production
                    };
                      prodList.push(currentHolderObject);
                    } else {
                        currentHolderObject = {
                          channelTypeId: holderValues[holderItem].channelTypeId,
                          apiToken: holderValues[holderItem].apiToken,
                          sandbox: holderValues[holderItem].sandbox
                        };
                      sandboxList.push(currentHolderObject);
                      }
                  } else {
                    currentHolderObject = {
                      id: holderValues[holderItem].id,
                      name: holderValues[holderItem].name,
                      description: holderValues[holderItem].description,
                    };
                    currentList.push(currentHolderObject);
                  }
                }
                if (endpoint === 'integrations') {
                  this.integrationListData$ = this.sharedService.getEnvironment() === 'prod' ? prodList : sandboxList;
                } else {
                  this.departmentListData$ = currentList;
                }
              } else {
                (endpoint === 'integrations') ? this.integrationListData$ = null : this.departmentListData$ = null;
              }
            }
        )
    ).subscribe(
        () => {
          return (endpoint === 'integrations') ? this.integrationListData$ : this.departmentListData$;
        },
        () => {
        }
    );
  }

  checkFlowIssue() {
    const flowIssue = JSON.parse(localStorage.getItem('flowIssue'));
    if (flowIssue && flowIssue.type === 'route') {
      const channelIndex = findIndex(this.availableChannels, { 'channel-name': flowIssue.channel });
      if (channelIndex !== -1 && this.selectedChannelIndex !== channelIndex) {
        this.selectedChannelIndex = channelIndex;
        this.tabGroup.selectedIndex = channelIndex;
      }
    }
    localStorage.removeItem('flowIssue');
  }

  checkValidRouteId(control: AbstractControl) {
    const chanel = this.availableChannels[this.selectedChannelIndex];
    if (chanel && control.value !== '') {
      const routesControlsList: any = this.routes.controls[chanel['channel-id']] || {};
      const routesList: Array<Object> = routesControlsList ? routesControlsList.value : [];
      return new Promise((resolve) => {
        const notSameRoute =
          !control.parent.value.currRouteId ||
          (control.parent.value.currRouteId && control.value !== control.parent.value.currRouteId);
        const checkSameId = find(routesList, { routeId: control.value });
        if (routesList && checkSameId && notSameRoute && control.dirty) {
          resolve({ nameError: control.value });
        }

        resolve(null);
      });
    }
  }

  ngAfterViewChecked() {
    const headerIntegrationBlock = <HTMLElement>(
      document.querySelector('#routing_header .routing_itemContainer')
    );
    const headerFlowBlock = <HTMLElement>document.querySelector('#routing_header .flow_block');
    const headerStepBlock = <HTMLElement>document.querySelector('#routing_header .step_block');

    const integrationBlock = <HTMLElement>(
      document.querySelector('#routing_form_block .routing_itemContainer')
    );
    const flowBlock = <HTMLElement>document.querySelector('#routing_form_block .flow_column_block');
    const stepBlock = <HTMLElement>document.querySelector('#routing_form_block .step_column_block');

    const headerIntegrationLabel = <HTMLElement>(
      document.querySelector('#routing_header .integration_block')
    );
    const integrationLabel = <HTMLElement>(
      document.querySelector('#routing_form_block .integration_block')
    );

    if (
      headerIntegrationBlock &&
      headerFlowBlock &&
      headerStepBlock &&
      integrationBlock &&
      flowBlock &&
      stepBlock
    ) {
      headerIntegrationBlock.setAttribute(
        'style',
        `width:${integrationBlock.offsetWidth + 30}px !important`
      );
      headerFlowBlock.setAttribute('style', `width:${flowBlock.offsetWidth}px !important`);
      headerStepBlock.setAttribute('style', `width:${stepBlock.offsetWidth}px !important`);
      headerIntegrationLabel.setAttribute(
        'style',
        `width:${integrationLabel.offsetWidth + 30}px !important`
      );
    }
  }

  newRoute() {
    this.enableRoute('', true);
    this.canSaveRoute = true;
    this.routeSavedOrDeleted = true;
    const availableChannels = this.availableChannels[this.selectedChannelIndex];
    if (!this.routes) {
      this.routes = new FormGroup({ channelId: new FormArray([]) });
    }
    const routes = this.routes.controls[availableChannels['channel-id']] as FormArray;

    routes.value.map((route) => {
      if (!route.hasOwnProperty('currRouteId') && route.routeId !== '') {
        route.currRouteId = route.routeId;
      }
    });

    const newFormGroup = new FormGroup({
      routeId: new FormControl('', [Validators.required], this.checkValidRouteId.bind(this)),
      flowName: new FormControl('', ),
      start: new FormControl('', ),
      flowService: new FormControl('chatFlow'),
      clientId: new FormControl(this.globalEnvironment.entityId),
      properties: this.createFormGroupProperties(availableChannels['property-layout'], true),
      currRouteId: new FormControl(''),
      isNew: new FormControl(true),
      serviceType: new FormControl(this.currentService.serviceType),
      providerType: new FormControl(this.currentService.providerType),
    });
    routes.push(newFormGroup);

    setTimeout(() => {
      const element = document.querySelectorAll('.mat-tab-body-content')[
        this.selectedChannelIndex
      ] as HTMLElement;
      element.scrollTo(pageXOffset, element.scrollHeight);
    }, 200);
  }

  saveRoutes() {
    if (this.routes.dirty && this.canSave()) {
      this.routeSavedOrDeleted = false;
      for (const channelId in this.routes.controls) {
        const formArray = this.routes.controls[channelId] as FormArray;
        if (formArray.dirty) {
          let message = 'Update: ';
          const editedRouteMap: {} = {};
          for (const key of formArray.controls) {
            const formGroup = key as FormGroup;
            if (formGroup.dirty) {
              const values = formGroup.value;
              if (values.flowService === 'chatFlow' && values.flowName === '') {
                this.routeSavedOrDeleted = true;
                this.showValidationFailedErrMsg();
                return false;
              }
              let route = new Route();
              values.currRouteId = values.routeId;
              const currentService = this.services.find((el) => el.id === values.flowService);

              route = {
                clientId: values.clientId,
                flowName: values.flowName,
                properties: values.properties,
                start: values.start,
                entityType: this.sharedService.getEntityType(),
                entityId: this.sharedService.getEntityId(),
                serviceType: currentService['serviceType'],
                providerType: currentService['providerType'],
              };
              editedRouteMap[values.routeId] = route;
              message += '\n ' + values.routeId;
            }
          }

          const currentRouteIDs: string[] = this.routes.controls[channelId].value.map(
            (item) => item.routeId
          );
          const previousRouteIDs: string[] = this.originalRouteIdMap[channelId].filter(
            (item) => !currentRouteIDs.includes(item)
          );

          // Getting new routes added
          const newRouteMap: string[] = Object.keys(editedRouteMap).filter(
              (item) => !this.originalRouteIdMap[channelId].includes(item)
          );
          this.newItemsRouteIdMap = this.newItemsRouteIdMap.concat(newRouteMap);

          // Checking which new routes have been deleted by the user
          const newRoutesToDelete = this.newItemsRouteIdMap.filter(
              (item) => !currentRouteIDs.includes(item)
          );

          this.routesToDelete = this.routesToDelete.concat(previousRouteIDs, newRoutesToDelete);
          this.canSaveRoute = false;

          const stageRequest: StageRequest = {
            message: message,
            routeMap: editedRouteMap,
            channelId: +channelId,
            routesToDelete: this.routesToDelete,
          };

          this.savingInProgress = true;
          this.flowManagerService.saveRoutes(stageRequest).subscribe(
            (res: any) => {
              this.savingInProgress = false;
              if (res && res.valid) {
                if (+channelId === this.CHANNELS.DYNAMIC_API) {
                  const channel = {
                    routes: res.routeMap
                  };
                  this.originalRouteIdMap[channelId] = res.routeMap;
                  this.routes.removeControl(channelId);
                  this.addChannelRouteFormArray(channelId, channel);
                }
                swalMini({
                  title: 'Routes saved successfully!',
                  type: 'success',
                });
              } else {
                swalMini({
                  title: 'Oops! something went wrong while saving.',
                  type: 'error',
                });
              }
            },
            (err) => {
              this.savingInProgress = false;
              if (err.status === 409) {
                swalMini({
                  title: 'Oops! something went wrong while saving. Conflicting integration id',
                  type: 'error',
                });
              }
            }
          );
        }
      }
    } else {
      this.showValidationFailedErrMsg();
    }
  }

  showValidationFailedErrMsg() {
    swalMini({
      title: 'Validation failed, please check for errors!',
      type: 'error',
    });
  }

  deleteRoute(index: number) {
    this.enableRoute('', true);
    this.canSaveRoute = true;
    this.routeSavedOrDeleted = true;
    this.resetOnDelete = false;
    // this.routesToDelete.push(routeId);
    const channelId = this.availableChannels[this.selectedChannelIndex]['channel-id'].toString();
    const formArray: FormArray = this.routes.controls[channelId] as FormArray;
    formArray.removeAt(index);
    setTimeout(() => {
      this.resetOnDelete = true;
      this.routes.updateValueAndValidity();
      this.routes.controls[channelId].markAsDirty();
    }, 1);
  }

  loadRouteData(channelIndex: number) {
    const channelId = this.availableChannels[channelIndex]['channel-id'].toString();
    if (!this.routes.controls[channelId]) {
      return this.flowManagerService.getChannelsById(channelId);
    } else {
      return EMPTY;
    }
  }

  private addChannelRouteFormArray(channelId, channel) {
    const routeFormArray: FormArray = new FormArray([]);
    if (!channel.hasOwnProperty('routes')) {
      channel.routes = {};
    }
    this.originalRouteIdMap[channelId] = Object.keys(channel.routes);
    for (const routeId in channel.routes) {
      routeFormArray.push(this.createFormGroup(routeId, channel.routes[routeId]));
    }
    this.routes.addControl(channelId, routeFormArray);
  }

  createFormGroup(routeId: string, route: Route): FormGroup {
    // flowName: string;
    // start: string;
    // clientId: number;
    // legacyClientId: number;
    // properties: { [index: string]: any };


    const index = route.flowName ? route.flowName.lastIndexOf('/') : -1;
    const flowId = index === -1 ? route.flowName : route.flowName.slice(index);
    const previousService = this.services.find(
      (itm) => itm.serviceType === route.serviceType && itm.providerType === route.providerType
    );
    const otherLayout =
      // this.availableChannels[this.selectedChannelIndex]['channel-id'] === 6 ||
      this.availableChannels[this.selectedChannelIndex]['channel-id'] === 8 ||
      this.availableChannels[this.selectedChannelIndex]['channel-id'] === 13;

    return new FormGroup({
      // {value:routeId, disabled: !this.canEdit()}
      originalRouteId: new FormControl(routeId), // do not change!!!! needed for apiToken regeneration
      isApiUrlCopied: new FormControl(false),
      isApiTokenCopied: new FormControl(false),
      isApiRegenerating: new FormControl(false),
      routeId: new FormControl(
        { value: routeId, disabled: !this.canEdit() },
        [Validators.required],
        this.checkValidRouteId.bind(this),
      ),
      flowName: new FormControl(
        { value: flowId, disabled: !this.canEdit() },
        otherLayout ? previousService.id === 'chatFlow' && Validators.required : Validators.required
      ),
      start: new FormControl(
        { value: route.start, disabled: !this.canEdit()  },
        otherLayout ? previousService.id === 'chatFlow' && Validators.required : Validators.required
      ),
      clientId: new FormControl({value: routeId, disabled: !this.canEdit()}),
      currRouteId: new FormControl({value: routeId, disabled: !this.canEdit()}),
      properties: this.createFormGroupProperties(route.properties),
      flowService: new FormControl({value: previousService ? previousService.id : 'chatFlow', disabled: !this.canEdit()}),
      serviceType: new FormControl({ value: route.serviceType, disabled: !this.canEdit() }),
      providerType: new FormControl({ value: route.providerType, disabled: !this.canEdit() }),
    });
  }

  addDynamicApiLayout(properties: Object, propertyLayout: any, newRoute: boolean): FormGroup {
    const propertiesFormGroup = new FormGroup({});
    const hasValidation: string[] = ['allowedSourceAddresses', 'method'];
    const hadDefault: object = {'async': false};
    for (const propertyKey in propertyLayout) {

      let value = '';

      if (!newRoute) {
        value = properties[propertyKey];
      } else if (hadDefault.hasOwnProperty(propertyKey)) {
        value = hadDefault[propertyKey];
      }

      if (hasValidation.includes(propertyKey)) {
        propertiesFormGroup.addControl(propertyKey, new FormControl({value, disabled: !this.canEdit()}, [Validators.required]));
        continue;
      }

      propertiesFormGroup.addControl(propertyKey, new FormControl({value, disabled: !this.canEdit()}));
    }
    return propertiesFormGroup;
  }

  addDefaultLayout(properties: Object, propertyLayout: any, newRoute: boolean): FormGroup {
    const propertiesFormGroup = new FormGroup({});
    for (const propertyKey in propertyLayout) {
      const value = newRoute ? '' : properties[propertyKey];
      if (propertyKey === 'api-key') {
        propertiesFormGroup.addControl(propertyKey, new FormControl({value, disabled: !this.canEdit()}, spaceOnName('Api key can`t contain space')));
        continue;
      }
      propertiesFormGroup.addControl(propertyKey, new FormControl({value, disabled: !this.canEdit()}));
    }
    return propertiesFormGroup;
  }

  getPropertyLayout(properties: Object, currentChannel: number, newRoute: boolean): FormGroup {
    const propertyLayout = this.availableChannels[this.selectedChannelIndex]['property-layout'];
    switch (currentChannel) {
      case CHANNELS.DYNAMIC_API:
        return this.addDynamicApiLayout(properties, propertyLayout, newRoute);
      default:
        return this.addDefaultLayout(properties, propertyLayout, newRoute);
    }
  }

  createFormGroupProperties(properties: Object, newRoute: boolean = false): FormGroup {
    const currentChannel = this.availableChannels[this.selectedChannelIndex]['channel-id'];

    const propertiesFormGroup: FormGroup = this.getPropertyLayout(properties, currentChannel, newRoute);

    if (this.initialChannelSet) {
    this.currentChannelId = currentChannel.toString();
    this.initialChannelSet = false;
    }

    if (
        currentChannel === CHANNELS.SMS ||
        currentChannel === CHANNELS.WHATSAPP ||
        currentChannel === CHANNELS.ABC
    ) {
      propertiesFormGroup.addControl('department', new FormControl({value: properties['department'], disabled: !this.canEdit()}));
      propertiesFormGroup.addControl('integration', new FormControl({value: properties['integration'], disabled: !this.canEdit()}));
    }
    return propertiesFormGroup;
  }

  channelChanged($event: MatTabChangeEvent) {
    this.selectedChannelIndex = $event.index;
    this.canSaveRoute = false;
    if (!this.flows) {
      this.flowManagerService.getFlows_with_ids().subscribe((data) => {
        this.flows = data;
        this.loadRouteDataObservable($event.index);
      });
    } else {
      this.loadRouteDataObservable($event.index);
    }
  }

  loadRouteDataObservable(index) {
    this.loadRouteData(index).subscribe((value) => {
      const channelId = this.availableChannels[index]['channel-id'].toString();
      this.selectedChannel = channelId;
      this.addChannelRouteFormArray(channelId, value);

      this.clearIntegrationsValue();
    });
  }

  clearIntegrationsValue() {
    if (this.integrationListData$) {
      const routesData = this.routes.getRawValue();
      for (const key in routesData) {
        const { sms, whatsApp, abc } = DISPLAY_TYPE_CHANNELS_KEYS;
        if (key === sms || key === whatsApp || key === abc) {
          routesData[key].map(route => {
            const { properties } = route;
            if (properties && properties.integration) {
              const integrationExist = find(this.integrationListData$, integration => {
                return integration.apiToken === properties.integration && integration.channelTypeId === +key;
              });

              if (!integrationExist) {
                properties.integration = '';
              }
            }
          });
        }
      }
      this.routes.patchValue(routesData);
    }
  }

  /**
   * Get all the flow name
   *
   * @function this.utils.getId()
   * gets the cashed client id
   *
   * @returns Observable<string[]>
   */
  getFlowMetaData() {
    if (!this.flowMetaData$) {
      this.flowMetaData$ = this.flowManagerService.getFlowMetaData(true).pipe(shareReplay(1));
    }
  }

  getFlows(): Observable<any> {
    if (!this.flows$) {
      this.flows$ = this.flowManagerService.getFlows_with_ids(true).pipe(shareReplay(1));
    }
    return this.flows$;
  }

  trackByFn(index) {
    return index; // or item.id
  }


  canEdit() {
    return this.rolesService.canEditRoutes(this.sharedService.getEnvironment());
  }


  enableRoute(key: string, flag: boolean) {
    this.canSaveRoute = true;
    this.routeSavedOrDeleted = true;
    switch (key) {
      case 'routeId':
        this.routeId = flag;
      // tslint:disable-next-line:no-switch-case-fall-through
      case 'flowName':
        this.flowName = flag;
      // tslint:disable-next-line:no-switch-case-fall-through
      case 'step':
        this.step = flag;
      // tslint:disable-next-line:no-switch-case-fall-through
      default:
        this.routeId = flag;
        this.flowName = flag;
        this.step = flag;
    }
  }

  canSave(): Boolean {
    const chanel = this.availableChannels[this.selectedChannelIndex];
    if (chanel) {
      return this.routes.controls[chanel['channel-id']].valid;
    }
    return false;
  }

  isModified(): Boolean {
    return this.canSaveRoute;
  }

  setCurrRouteId(route, i) {
    const availableChannels = this.availableChannels[this.selectedChannelIndex];
    const routes = this.routes.controls[availableChannels['channel-id']] as FormArray;
    const currControls = routes.controls[i] as FormGroup;
    const controls = currControls.controls;

    if (controls.routeId && controls.routeId.valid) {
      const currValue = controls.routeId.parent.value;
      currValue.currRouteId = route.routeId;
      controls.routeId.parent.setValue(currValue);
    }
  }

  getFlowNameWidth( flowName: string) {
    const canvas = document.createElement('canvas');
    const flowNameDisplay = canvas.getContext('2d');
    flowNameDisplay.font = '500 12px "NeueHaasGroteskTextPro-65", sans-serif';
    return flowNameDisplay.measureText(flowName).width;
  }

  // This needs to be refactored
  getSelectorData(channelId, index, controlName, request) {

    let flowName = '';
    let rootFolder = '';
    let isRootFolderPresent = false;
    let isMultipleFoldersPresent = false;
    let isEllipsesPresent = false;
    let multipleFoldersWidth = 0;

    const rootFolderIcons = 52;
    const flowNameIcons = 33;
    const ellipsesIcons = 27.5;

    const multipleFolders = [];
    const routesList = this.routes.controls[channelId] as FormArray;
    const flowKey = routesList.controls[index].get(controlName).value;
    const flowPath = Object(this.flows)[flowKey];

    /*No flow step set */
    if (flowPath === undefined) {
      return null;
    }

    if (request === this.flowPathRequest.flowFullPath) {
      if (flowPath.indexOf('/') !== -1) {
        const pathSplit = flowPath.split('/');
        pathSplit.pop();
        return pathSplit.join('/') + '/';
      } else {
        return flowPath;
      }
    }

    /*Resolving the flow step*/
    const flowStep = routesList.controls[index].get('start').value;
    if (request === this.flowPathRequest.flowStep) {
      if (flowStep === 'start') {
        return flowStep;
      } else {
        const flowNum = flowStep.replace('step', '');
        return flowNum;
      }
    }

    if (flowPath.indexOf('/') !== -1) {

      const pathSplit = flowPath.split('/');
      const count = pathSplit.length - 1;
      isRootFolderPresent = true;
      rootFolder = pathSplit[0];
      flowName = pathSplit[pathSplit.length - 1];

      if (request === this.flowPathRequest.flowName) {
          return flowName;
      }

      if (request === this.flowPathRequest.flowRootFolder) {
        return rootFolder;
      }

      if (count > 1 ) {
        isMultipleFoldersPresent = true;
        let multipleFolderWidthTemp = 0;

        for (let i = 1; i < pathSplit.length - 1; i++) {

          /*Folder we are attempting to add*/
          const folderName = pathSplit[i];

          const folderSize = Math.ceil(this.getFlowNameWidth(folderName)) + rootFolderIcons;

          const container: HTMLElement = document.getElementById('selectorContainer' + channelId + '' + index);

          if ( container != null) {

            const availableWidth = container.offsetWidth;

            /*remainingWidth = availableWidth - rootFolder - flowName - folders added already*/
            let remainingWidth = availableWidth
                - (Math.ceil(this.getFlowNameWidth(rootFolder)) + rootFolderIcons)
                - (Math.ceil(this.getFlowNameWidth(flowName) + flowNameIcons)) - multipleFolderWidthTemp;
            remainingWidth -= 5;

            if (remainingWidth > folderSize) {
              multipleFolders.push(folderName);
               multipleFolderWidthTemp += folderSize;
            } else {
              isEllipsesPresent = true;
              multipleFolderWidthTemp += ellipsesIcons;
              if (remainingWidth < (ellipsesIcons)) {
                multipleFolderWidthTemp -= (Math.ceil( this.getFlowNameWidth(multipleFolders.pop()))
                    + rootFolderIcons);
              }
            }
          }
        }

        multipleFoldersWidth  = multipleFolderWidthTemp;
      }

    } else {
      /*flowPath has no folders*/
      if (request === this.flowPathRequest.flowName) {
        return flowPath;
      }
    }
    if (request === this.flowPathRequest.flowPathContainerWidth) {
      const container: HTMLElement = document.getElementById('selectorContainer' + channelId + '' + index);
      if (container != null) {
        const containerWidth = container.offsetWidth;
        return containerWidth
            - (Math.ceil(this.getFlowNameWidth(rootFolder))
            + rootFolderIcons
            + flowNameIcons)
            - (Math.ceil(this.getFlowNameWidth(multipleFolders.join())))
            - multipleFolders.length * (this.flowPathRequest.isMultipleFoldersPresent ? 52 : 0)
            - (this.flowPathRequest.isEllipsesPresent ? 27.5 : 0);
      }
    } if (request === this.flowPathRequest.multipleFoldersList) {
      return multipleFolders;
    } else if (request === this.flowPathRequest.isEllipsesPresent) {
      return isEllipsesPresent;
    } else if (request === this.flowPathRequest.isRootFolderPresent) {
      return isRootFolderPresent;
    } else if (request === this.flowPathRequest.isMultipleFoldersPresent) {
      return isMultipleFoldersPresent;
    }

  }

  /*Next Step Selection*/

  openFlowStepSelectionModal(name, step, channelId, index, status) {

    const routesList = this.routes.controls[channelId] as FormArray;
    const flowKey = routesList.controls[index].get('flowName').value;
    const flowPath = Object(this.flows)[flowKey];

    if (flowPath !== undefined || status !== 'New') {
      if (flowPath.indexOf('/') !== -1) {

        const pathSplit = flowPath.split('/');
        const flowName = pathSplit[pathSplit.length - 1];
        pathSplit.pop();
        pathSplit.push(flowKey);

        this.flowBuilderService.setCurrFlow({name: flowKey, path: pathSplit.join('/'), title: flowName});
      } else {
        this.flowBuilderService.setCurrFlow({name: flowKey, path: flowKey, title: Object(this.flows)[flowKey]});
      }

      if (status === 'New') {
        this.setFlowStepSelectionFormField({controlName: name, step: step});
      } else {
        this.setFlowStepSelectionFormField({controlName: flowKey + ':' + 'step' + step , step: 'step' + step});
      }

    } else {
      this.setFlowStepSelectionFormField({controlName: 'NextStep', step: 'NextStep'});
    }

    this.editFlowInformation = {channelId: channelId, index: index};
    if (CHANNELS.DYNAMIC_API === channelId) {
      this.stateService.setFlowMode(FlowModeState.API_FLOW_MODE);
    } else {
      this.stateService.setFlowMode(FlowModeState.FLOW_MODE);
    }
    this.showFlowStepSelectionModal = true;

  }

  closeFlowStepSelectionModal(value) {
    this.showFlowStepSelectionModal = false;
    if (value) {
      const routesList = this.routes.controls[this.editFlowInformation.channelId] as FormArray;
      routesList.controls[this.editFlowInformation.index].get('start').setValue(value.substring(value.lastIndexOf(':') + 1));
      routesList.controls[this.editFlowInformation.index].get('flowName').setValue(value.substring(0, value.indexOf(':')));

      routesList.controls[this.editFlowInformation.index].markAsDirty();
      routesList.controls[this.editFlowInformation.index].markAsTouched();

      this.routeSavedOrDeleted = true;

      /*Saving if there is a value*/
      this.routes.controls[this.editFlowInformation.channelId].get(this.flowStepSelectionFormField.controlName).setValue(value);
    }
    this.flowBuilderService.setCurrFlow('');
    this.clearFlowStepSelectionFormField();
  }

  setFlowStepSelectionFormField(field) {
    this.flowStepSelectionFormField = field;
  }

  clearFlowStepSelectionFormField() {
    this.flowStepSelectionFormField = null;
  }

  getFlowStepSelectionValue() {
    const data = this.flowStepSelectionFormField;
    if (data) {
      return {
        step: data.step,
        selected: data.controlName
      };
    }
  }

  dynamicInputboxChange() {
    this.routeSavedOrDeleted = true;
  }

  checkIfEdited() {
    if (this.routes.dirty) {
      this.routeSavedOrDeleted = true;
    }
  }

  openApiSettings(index: number) {
    const settings: HTMLDivElement = document.getElementById(`apiSettings-${index}`) as HTMLDivElement;

    if (settings.style.height === '0px' || settings.style.height === '0') {
      // settings.style.display = "block";
      settings.style.height = '150px';
    } else {
      // settings.style.display = "none"
      settings.style.height = '0px';
    }
  }

  urlCopied(copied: boolean, route: Route) {
    if (copied) {
      route.isApiUrlCopied = true;
    }
  }

  copyApiToken(route: Route) {
    this.isApiTokenCopied = false;
    this.routeApiTokenService.getRouteApiToken(route.originalRouteId)
        .pipe(
            map(apiToken => this.clipboard.beginCopy(apiToken)),
            take(1),
            mergeMap(pending => {
              return new Observable((subscriber) => {
                let remainingAttempts = 3;
                const attempt = () => {
                  const result = pending.copy();
                  if (!result && --remainingAttempts) {
                    subscriber.next(false);
                    setTimeout(attempt);
                  } else {
                    route.isApiTokenCopied = true;
                    // Remember to destroy when you're done!
                    pending.destroy();
                    subscriber.next(true);
                    subscriber.complete();
                  }
                };
                attempt();
              });
            })
        ).subscribe();

    // get apiToken from /jwt/{routeId}
    // apiToken to clipboard
  }
  regenerateApiToken(route: Route) {
    const availableChannels = this.availableChannels[this.selectedChannelIndex];
    const routes = this.routes.controls[availableChannels['channel-id']] as FormArray;
    const routeIndex = routes.controls.findIndex(routeControl => route.originalRouteId === routeControl.value.originalRouteId);
    routes.at(routeIndex).get('isApiRegenerating').setValue(!route.isApiRegenerating);
    this.routeApiTokenService.generateToken(route.originalRouteId)
        .subscribe(tokenResponse => {
          const control = routes.at(routeIndex).get('properties');
          control.patchValue({
            apiToken: tokenResponse.route.properties.apiToken // masked token
          });
          this.routeSavedOrDeleted = true;
          // load token response for apiToken into localstorage
        });
  }
}



